(ns ycweb.app.website.dlp.widgets.simpleimage
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc load-image < rum/reactive [app-atom {:keys [url link-type alt public-id width shadow border]}]
  (let [image
        (list
          (web-common/lazy-image app-atom
            public-id
            {:class (u/bem :yc-simple-image [:full (when shadow :shadow) (when border :border)])}
            {:w width
             :mw 490
             :alt alt}))]
    (cond
      (not (empty? url))
      (u/wrap-element
        url
        [:a
         (merge
           (when (= link-type "onpage")
             (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace url #"\#" ""))))
           {:href url
            :class "u-block-link"})]
        image)

      :else
      image)))

(rum/defc simple-image < rum/reactive [app-atom page {:keys [properties]}]
  (let [{:simple-image/keys
         [on-page-link-id number-of-images image-width
          image-left-align? image-caption image-shadow? image-border?
          image-1-public-id image-1-alt image-1-url image-1-link-type image-1-split-2? image-1-split-3?
          image-2-public-id image-2-alt image-2-url image-2-link-type image-2-split-2?
          image-3-public-id image-3-alt image-3-url image-3-link-type
          image-4-public-id image-4-alt image-4-url image-4-link-type]} properties

        number-of-images (trf/tonumber number-of-images)
        simple-image-width
        (cond
          (= image-width "small")
          480

          (= image-width "medium")
          640

          (= image-width "large")
          720

          :else
          320)

        multi-image-width
        (cond
          (= number-of-images 2)
          490

          (= number-of-images 3)
          486

          (= number-of-images 4)
          316)

        one-image
        (or
          (= number-of-images 1)
          (not number-of-images))]

    (when image-1-public-id
      [:div.yc-section
       {:id (when (u/presence on-page-link-id) on-page-link-id)
        :class
        (when
          (and
            image-left-align?
            (and
              (> (trf/tonumber (:isarticle page)) 0)
              one-image))
          " u-max-width-720")}
       [:div
        {:class
         (u/bem :flex-grid-group
           [(when
              (and
                image-left-align?
                one-image)
              :align-left)])}
        [:div
         {:class
          (u/bem :flex-grid-block
            [(cond
               (not number-of-images)
               :m-1-1

               (= number-of-images 4)
               [:m-1-4 :t-1-2]

               :else
               (keyword (str "m-1-" number-of-images)))
             (when image-left-align? :flush)])}
         [:div.flex-grid-content
          [:div
           {:class
            (str
              (when one-image
                (str "u-max-width-" simple-image-width))
              (when (not image-left-align?) " u-block-center"))}
           [:div
            {:class
             (when
               (and
                 image-border?
                 (or image-1-split-2? image-1-split-3?))
               (u/bem :yc-simple-image-wrapper
                 [(cond
                    (and image-1-split-3? (= number-of-images 1))
                    :split-3

                    (and image-1-split-2? (< number-of-images 3))
                    :split-2)]))}
            (load-image app-atom
              {:url image-1-url
               :link-type image-1-link-type
               :alt image-1-alt
               :public-id image-1-public-id
               :shadow image-shadow?
               :border image-border?
               :width
               (cond
                 (= number-of-images 1)
                 simple-image-width

                 :else
                 multi-image-width)})]]]]
        (when (and image-2-public-id (> number-of-images 1))
          [:div
           {:class
            (u/bem :flex-grid-block
              [(when (or (= number-of-images 3) (= number-of-images 4))
                 :t-1-2)
               (cond
                 (= number-of-images 2)
                 :m-1-2

                 (= number-of-images 3)
                 :m-1-3

                 :else
                 :m-1-4)])}
           [:div.flex-grid-content
            [:div
             {:class
              (when (and image-border? (and image-2-split-2? (= number-of-images 2)))
                (u/bem :yc-simple-image-wrapper [:split-2]))}
             (load-image app-atom
               {:url image-2-url
                :link-type image-2-link-type
                :alt image-2-alt
                :public-id image-2-public-id
                :shadow image-shadow?
                :border image-border?
                :width multi-image-width})]]])
        (when (and image-3-public-id (> number-of-images 2))
          [:div
           {:class
            (u/bem :flex-grid-block
              [:t-1-2
               (cond
                 (= number-of-images 3)
                 :m-1-3

                 :else
                 :m-1-4)])}
           [:div.flex-grid-content
            [:div
             {:class (when image-border? "yc-simple-image-wrapper")}
             (load-image app-atom
               {:url image-3-url
                :link-type image-3-link-type
                :alt image-3-alt
                :public-id image-3-public-id
                :shadow image-shadow?
                :border image-border?
                :width multi-image-width})]]])
        (when (and image-4-public-id (= number-of-images 4))
          [:div
           {:class (u/bem :flex-grid-block [:t-1-2 :m-1-4])}
           [:div.flex-grid-content
            [:div
             {:class (when image-border? "yc-simple-image-wrapper")}
             (load-image app-atom
               {:url image-4-url
                :link-type image-4-link-type
                :alt image-4-alt
                :public-id image-4-public-id
                :shadow image-shadow?
                :border image-border?
                :width multi-image-width})]]])]
       (when image-caption
         [:div
          [:figcaption.yc-simple-image__caption
           image-caption]])])))
